module.exports = __webpack_public_path__ + "static/media/cloudnetwork.f945d19b.svg";